import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './style.css';
var enableLogging = false;
if (enableLogging) {
    console.log('WCCF Participant Details App is starting...');
}
/**
 * Expose a function on the window object that our loader script can call.
 * This function will be responsible for mounting the React app.
 * @param {HTMLElement} targetElement - The DOM element to mount the app into.
 */
window.mountWccfParticipantDetailsApp = function (targetElement) {
    if (enableLogging) {
        console.log('Mounting WCCF Participant Details App...');
    }
    if (targetElement) {
        if (enableLogging) {
            console.log('Root element found, rendering React app into:', targetElement);
        }
        var root = ReactDOM.createRoot(targetElement);
        root.render(React.createElement(React.StrictMode, null,
            React.createElement(App, null)));
    }
    else {
        console.error('Target element not provided for mounting the React app.');
    }
};
